import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'inProcessOrders';
export const inProcessOrdersActions = makeActions(
  MODEL_NAME,
  'id',
  'order-item-stocks',
);

export const getAllInProcessOrders = inProcessOrdersActions.getAll;
export const editInProcessOrders = inProcessOrdersActions.edit;
export const createInProcessOrders = inProcessOrdersActions.create;
export const getByIdInProcessOrders = inProcessOrdersActions.getDataById;
